var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "w-dialog",
    {
      staticClass: "pop-dialog",
      attrs: {
        closeFree: "",
        width: "268px",
        title: "提示",
        top: "calc(50vh - 200px)",
      },
      on: { ok: _vm.onOk },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [_c("div", { staticClass: "dialog-title" }, [_vm._v(_vm._s(_vm.title))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }